// src/stores/loaderStore.js
import { acceptHMRUpdate, defineStore } from "pinia"
import { ref } from "vue"

export const useLoaderStore = defineStore("loader", () => {
  const isLoading = ref(false)

  const showLoader = () => {
    isLoading.value = true
  }
  const hideLoader = () => {
    isLoading.value = false
  }

  return { isLoading, showLoader, hideLoader }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useLoaderStore, import.meta.hot))
}
